import { render, staticRenderFns } from "./SettlementBatchPaymentModal.vue?vue&type=template&id=16b97d38&scoped=true"
import script from "./SettlementBatchPaymentModal.vue?vue&type=script&lang=js"
export * from "./SettlementBatchPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./SettlementBatchPaymentModal.vue?vue&type=style&index=0&id=16b97d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b97d38",
  null
  
)

export default component.exports